import api from './client';

export const getMembers = (params?: any) => api.get('/members', { params });
export const getMember = (id: number) => api.get(`/members/${id}`);
export const createMember = (data: any) => api.post('/members', data);
export const updateMember = (id: number, data: any) => api.put(`/members/${id}`, data);
export const getMemberFines = (id: number) => api.get(`/members/${id}/fines`);
